import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { parseString } from 'xml2js';
import { map, mapObjIndexed, path, head } from 'ramda';
import Translate from 'react-translate-component';

const extract = (item) => mapObjIndexed((prop) => path(['0', 'rus', '0'], prop) || head(prop) || prop, item);

export default class DocumentXMLTest extends Component {
    static propTypes = {
        body: PropTypes.string.isRequired,
        document: PropTypes.object.isRequired,
    };

    state = {
        table: null
    }

    componentDidMount() {
        const { body } = this.props;
        if (!body) return;

        parseString(body.replace(/&/g, '&amp;'), (err, { root }) => {
            if (!root) return;

            const table = {};
            table.id = path(['tool', '0', '$', 'id'], root);
            table.title = path(['tool', '0', 'title', '0', 'rus', '0'], root);
            table.items = map(extract, path(['scores', '0', 'score'], root));

            this.setState({ table });
        });
    }

    renderHeader(table) {
        return (
            <tr>
                <th colSpan="3">
                    <div className="text-center">{table.title}</div>
                    <div className="text-center">{table.id}</div>
                </th>
            </tr>
        );
    }

    renderItems(items) {
        let currentScale;

        return map((item) => {
            let scale = path(['$', 'scale'], item);
            scale = currentScale !== scale && scale;

            if (scale) {
                currentScale = scale;
            }

            return (
                <Fragment key={`${item.id}_${currentScale}`}>
                    { scale && (
                        <tr>
                            <td colSpan={3} className="text-center">
                                <Translate content={`xml.test.scales.${currentScale}`} fallback={scale} />
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td>{item.name}</td>
                        <td className="text-center">{item.value}</td>
                        <td>{item.id}</td>
                    </tr>
                </Fragment>
            );
        }, items);
    }

    render() {
        const { table } = this.state;

        return (
            <div className="preview-paddings">
                <table className="shl-table">
                    <thead>
                        { table && this.renderHeader(table) }
                        <tr>
                            <th width="40%" className="text-center"><Translate content="xml.test.name" /></th>
                            <th width="20%" className="text-center"><Translate content="xml.test.score" /></th>
                            <th width="40%" className="text-center"><Translate content="xml.test.id" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        { table && this.renderItems(table.items) }
                    </tbody>
                </table>
            </div>
        );
    }
}
